export default {
    title: "登錄",
    uname: "請輸入登錄賬號",
    pwd: "請輸入密碼",
    forget: "忘記密碼？",
    login: "立即登錄",
    havenot: "沒有賬號？",
    register: "立即註冊",
    succ: "登錄成功！",
    succBtn: "去首頁",
    err: "您還未輸入登錄信息！",
}